import dayjs from 'dayjs'

import { isNull } from '@app/utils'

import { dateFormat } from '@app/constants'

import type { ScheduleFormData } from './types'
import type { ScheduleData } from '../types'

export const scheduleFormDataAdapter = (scheduleFormData: ScheduleFormData): ScheduleData => {
  return Object.entries(scheduleFormData).reduce((result: ScheduleData, [scheduleKey, scheduleDate]) => {
    if (isNull(scheduleDate)) return result

    // TODO: Вернуть таймзону, как будет готов бэк к обработке (убрать dateFormat.YYYY_MM_DDTHH_mm_ss из метода format())
    // Добавить формат с часовым поясом
    const scheduleFormattedDate = dayjs(scheduleDate).format(dateFormat.YYYY_MM_DDTHH_mm_ss)

    return {
      ...result,
      [scheduleKey]: scheduleFormattedDate
    }
  }, {})
}
